import { render } from "./Speaker50.vue?vue&type=template&id=1ffc3706"
import script from "./Speaker50.vue?vue&type=script&lang=js"
export * from "./Speaker50.vue?vue&type=script&lang=js"
script.render = render

export default script